<template>
  <button-activable label small titlePath="sidebar.fixedAssets.unassigned" v-model="isActive" />
</template>
<script>
import { get } from 'vuex-pathify';
import ButtonActivable from '@/components/ButtonActivable';
export default {
  name: 'TableButtonFixedAssetsUnassign',
  components: { ButtonActivable },
  computed: {
    dataSources: get('layers/metadata'),
    fixedAssetsMapping: get('admin/modulesMapping@fixed_assets.fixed_assets_datasource'),
    dataSourceName() {
      return this.fixedAssetsMapping.datasource;
    },
    lengthAttributeName() {
      return this.fixedAssetsMapping.settings?.length_attribute;
    },
    useQualifiedNames() {
      return this.dataSources[this.dataSourceName]?.attributes_use_datasource_qualified_names || false;
    },
  },
  data: () => ({
    isActive: false,
  }),
  methods: {
    getFilterExpression() {
      const filterAttrbuteName = this.useQualifiedNames
        ? this.lengthAttributeName
        : `${this.dataSourceName}.${this.lengthAttributeName}`;
      return {
        '!OR': [
          {
            $EQUAL: {
              [filterAttrbuteName]: {
                value: 0,
              },
            },
          },
          {
            IS_NULL: filterAttrbuteName,
          },
        ],
      };
    },
    setFilter(value) {
      this.$root.$emit('setAdditionalFilters', value ? this.getFilterExpression() : undefined);
    },
  },
  watch: {
    isActive: {
      immediate: true,
      handler(nV) {
        this.setFilter(nV);
      },
    },
  },
  beforeDestroy() {
    this.$root.$emit('setAdditionalFilters', undefined);
  },
};
</script>
